import cx from "classnames"
import ComposableCard from "src/shared/components/data-display/composable-card/ComposableCard"
import { getCurrencyFormat } from "src/utils/string"
import { ResumenCorteTickets } from "../../Sections/ResumenTurno/interfaces/resumenCorteTickets"

const positive = (value?: number) => (value && value > 0 ? value : 0)

const EfectivoRow = ({
    title,
    value,
    valueClassName = "",
    onValueClick,
}: {
    title: string
    value: number
    valueClassName?: string
    onValueClick?: () => void
}) => (
    <ComposableCard.Row className="cortes-screen__efectivo-row">
        <p className="composable-card__title cortes-screen__efectivo-title">{title}</p>
        <p
            className={cx(
                "composable-card__value cortes-screen__efectivo-value",
                { "composable-card__value_clickable": !!onValueClick },
                valueClassName
            )}
            onClick={onValueClick}
        >
            {getCurrencyFormat(value)}
        </p>
    </ComposableCard.Row>
)

export const Cards = ({ data, onLinkFajillas }: { data: ResumenCorteTickets["dashboard"]; onLinkFajillas: () => void }) => {
    return (
        <div className="cortes-screen__cards animante__select">
            <ComposableCard>
                <ComposableCard.Value
                    title="Total del turno"
                    value={data?.total_turno || 0}
                    tooltip={{
                        title: "Total del turno",
                        description: "Corresponde al total de ingresos, descontando gastos y anticipos válidos.",
                    }}
                />
                <ComposableCard.Value
                    title="Total de ingresos"
                    value={data?.total_ventas || 0}
                    tooltip={{
                        title: "Total de ingresos",
                        description:
                            "Es la sumatoria de todos los ingresos incluyendo los métodos de pago y anticipos válidos.",
                    }}
                />
            </ComposableCard>

            <ComposableCard className="cortes-screen__card-efectivo">
                <EfectivoRow title="Efectivo en caja" value={positive(data?.efectivo_caja)} />
                <EfectivoRow
                    title="Efectivo para retiro"
                    value={positive(data?.disponible_retiro)}
                    valueClassName="composable-card__value_variant_highlight"
                />
                <EfectivoRow
                    title="Efectivo retirado"
                    value={data?.total_fajillas || 0}
                    valueClassName="composable-card__value_variant_link"
                    onValueClick={onLinkFajillas}
                />
            </ComposableCard>

            <ComposableCard>
                <ComposableCard.Value title="Visa y Mastercard" value={data?.visa_mastercard || 0} />
                <ComposableCard.Value title="AMEX" value={data?.amex || 0} />
            </ComposableCard>

            <ComposableCard>
                <ComposableCard.Value title="Consumo interno" value={data?.consumo_interno || 0} />
                <ComposableCard.Value title="Cortesías" value={data?.cortesia || 0} />
            </ComposableCard>

            <ComposableCard>
                <ComposableCard.Value title="Easyrewards" value={data?.easy_rewards || 0} />
                <ComposableCard.Value title="Transfer/ Depósitos" value={data?.depositos_transfer || 0} />
            </ComposableCard>

            <ComposableCard>
                <ComposableCard.Value title="Anticipos válidos" value={data?.anticipos_validos || 0} />
                <ComposableCard.Value
                    title="Gastos en caja"
                    value={Math.abs(Number(data?.gastos || 0))}
                    valueClassName="cortes-screen__value_gastos"
                />
            </ComposableCard>
        </div>
    )
}